import { api } from './api';
import { intervals, intervalsExclude, intervalsMap } from './interval';
import { rotation, rotationMap } from './rotation';
import { alert } from './alert';
import { bidActionOptions, bidUnitOptions, bidToOptions, bidModelTemplates, generateBidOptions } from './bid';
import { budgetActionOptions, budgetUnitOptions, budgetToOptions, budgetModelTemplates } from './budget';
import { ruleTypes, enabledTypes } from './ruleTypes';
import Conditions from './conditions';
import RuleModel from './RuleModel';

export default {
  async getConfig() {
    const { fieldsGroup, fields, fieldsMap, conditions, conditionsTranslator, conditionsDailyCap, toFields } = await Conditions.getData();
    return {
      alertConfig: { alert },
      intervalsConfig: { intervals, intervalsExclude, intervalsMap },
      rotationConfig: { rotation, rotationMap },
      conditionsConfig: { fieldsGroup, fields, fieldsMap, conditions, conditionsTranslator, conditionsDailyCap, toFields },
      bidConfig: { bidActionOptions, bidUnitOptions, bidToOptions, bidModelTemplates, generateBidOptions },
      budgetConfig: { budgetActionOptions, budgetUnitOptions, budgetToOptions, budgetModelTemplates },
      ruleConfig: { ruleTypes, enabledTypes },
      api,
      RuleModel,
    };
  },
};
